import * as React from 'react';

type ActionUndoProps = Omit<React.SVGAttributes<SVGElement>, 'viewbox' | 'xmlns'>;

export const ActionUndo: React.FC<ActionUndoProps> = (props) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 0C4.47688 0 0 4.47688 0 10C0 15.5231 4.47688 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47688 15.5231 0 10 0ZM6.875 5.56625L10 8.69125L13.125 5.56625L14.4338 6.875L11.3088 10L14.4338 13.125L13.125 14.4338L10 11.3088L6.875 14.4338L5.56625 13.125L8.69125 10L5.56625 6.875L6.875 5.56625Z" />
    </svg>
  );
};
